<template>
  <div class="rating-feedback">
    <div v-if="!hasRated" class="rating-container">
      <h2 class="title">
        {{ $t('rating_modal_title') }}
      </h2>
      <p class="subtitle">
        {{ $t('rating_modal_subtitle') }}
      </p>

      <div class="stars-container">
        <button
          v-for="star in 5"
          :key="star"
          :aria-label="$t('rating_modal_rate_star', { stars: star })"
          class="star-button"
          @click="rate(star)"
          @mouseover="hoverRating = star"
          @mouseleave="hoverRating = 0"
        >
          <img
            :src="getStarIcon(star)"
            :alt="$t('rating_modal_star_alt', { star: star })"
            class="star"
          />
        </button>
      </div>
    </div>

    <div v-else-if="hasRated" class="thank-you-container">
      <template v-if="showTrustpilotLink">
        <h2 class="title">
          {{ $t('rating_modal_thank_you') }}
        </h2>
        <p class="subtitle">
          {{ $t('rating_modal_trustpilot_prompt') }}
        </p>
      </template>
      <template v-else>
        <h2 class="title">
          {{ $t('rating_modal_thank_you') }}
        </h2>
        <p class="subtitle">
          {{ $t('rating_modal_trustpilot_prompt_no_1') }}
          <a href="mailto:buggar@lagenhetsbyte.se">{{
            $t('rating_modal_trustpilot_prompt_no_2')
          }}</a>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'RatingTrustpilot',

  data() {
    return {
      hasRated: false,
      rating: 0,
      hoverRating: 0
    };
  },

  computed: {
    showTrustpilotLink() {
      return this.rating >= 4;
    }
  },

  methods: {
    ...mapActions({
      sendTrustpilotReview: 'propositions/sendTrustpilotReview'
    }),
    rate(stars) {
      this.rating = stars;
      this.hasRated = true;

      if (stars >= 4) {
        this.sendTrustpilotReview();
      }
    },

    closeModal() {
      this.$emit('close');
    },

    getStarIcon(star) {
      const isFilled = star <= (this.hoverRating || this.rating);
      return isFilled
        ? require('@/assets/svg/star-gold-filled.svg')
        : require('@/assets/svg/star-gold-empty.svg');
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-feedback {
  text-align: center;
  padding: 1rem 0;
  max-width: 500px;
  margin: 0 auto;
}

.title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.stars-container {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin: 1.5rem 0;
}

.star-button {
  background: none;
  border: none;
  padding: 0.2rem;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.2);
  }

  &:focus-visible {
    outline: 2px solid blue;
  }
}

.star {
  width: 40px;
  height: 40px;
  transition: all 0.2s ease-in-out;
}
</style>
